import { ChangeEvent, KeyboardEvent, useRef } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { useSYS3010_R01Store } from "src/containers/mes/SYS/SYS3010_R01/Store_SYS3010_R01";

interface Props {
  onUserNmChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchSection_SYS3010_R01 = (props: Props) => {

	const { onUserNmChange, onEnterKeyDown } = props;

	const { SYS3010_R01Filter, setSYS3010_R01Filter } = useSYS3010_R01Store();

  return (
    <SearchSectionForm>
		<SearchInputForm
			label="사용자명"
			value={SYS3010_R01Filter.userNm}
			onChange={onUserNmChange}
			initValue={() => setSYS3010_R01Filter({userNm: ''})}
			onKeyDown={onEnterKeyDown}
			className="h-[80%] flex items-center gap-[12px]"
		/>
	</SearchSectionForm>
  );
};